import set from 'transmute/set';
export const setThreadRemovalMembers = set('members');